<template>
  <div class="container-main-div">
    <!-- ++++++++++++ Radio Buttons ++++++++++++++++++++++++++++ -->

    <div class="fieldset">
      <form>
        <fieldset class="customLegend row">
          <legend style="margin-left: 30px">Choose Control Setup</legend>
          <div class="float-container">
            <!-- ----------- grid only ------------- -->
            <div class="float-child">
              <input
                type="radio"
                @change="handleRadioChange()"
                id="gridOnlyID"
                name="setup"
                checked
              />
              <label class="lableMargin" for="setup">Grid Only</label>
            </div>
            <!-- ----------- paging ------------- -->
            <div class="float-child">
              <input
                type="radio"
                @change="handleRadioChange()"
                id="pagingOnlyID"
                name="setup"
              />
              <label class="lableMargin" for="setup">Paging</label>
            </div>
            <!-- ----------- searching ------------- -->
            <div class="float-child-large">
              <input
                type="radio"
                @change="handleRadioChange()"
                id="searchingOnlyID"
                name="setup"
              />
              <label class="lableMargin" for="setup">Searching</label>
            </div>
            <!-- ----------- page-search ------------- -->
            <div class="float-child-large">
              <input
                type="radio"
                @change="handleRadioChange()"
                id="pageSearchID"
                name="setup"
              />
              <label class="lableMargin" for="setup">page-search</label>
            </div>
          </div>
        </fieldset>
      </form>
    </div>

    <!-- ++++++++++++ Grid Only ++++++++++++++++++++++++++++ -->

    <div v-if="gridOnly == true" class="gridWidth">
      <CmpGrid :GridData="gridTime"></CmpGrid>
    </div>

    <!-- ++++++++++++ Paging Only ++++++++++++++++++++++++++++ -->

    <div v-if="pagingOnly == true" class="gridWidth">
      <CmpGrid :GridData="gridTime" :EnablePaging="true"></CmpGrid>
    </div>

    <!-- ++++++++++++ Searching Only ++++++++++++++++++++++++++++ -->

    <div v-if="searchOnly == true" class="gridWidth">
      <CmpGrid :GridData="gridTime" :EnableSearching="true"></CmpGrid>
    </div>

    <!-- ++++++++++++ Page Searching ++++++++++++++++++++++++++++ -->

    <div v-if="pageSearch == true" class="gridWidth">
      <CmpGrid
        :GridData="gridTime"
        :EnablePaging="true"
        :EnableSearching="true"
      ></CmpGrid>
    </div>
  </div>
</template>

<script>
import CmpGrid from "../../../components/dataSupport/CmpGrid.vue";
import axios from "axios";

export default {
  name: "HomeView",
  data() {
    return {
      gridTime: { grid: null, time: null },
      gridOnly: true,
      pagingOnly: false,
      searchOnly: false,
      pageSearch: false,

      prettyIsChecked: false,
    };
  },
  created() {
    console.log("----> HostCmpGrid.vue:created()");
    this.getAllUsers();
  },

  methods: {
    getAllUsers() {
      console.log("HostCmpGrid.vue:getAllUsers()");
      axios
        .get("https://localhost:7100/api/User/SelAllUsers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          console.log("---->> last then: HostCmpGrid getAllUsers()");
          // console.log("data = ", data);
          // console.log("data.length = ", data.length);
        });
    },

    handleRadioChange() {
      let gridOnlyRadioBtn = document.querySelector("#gridOnlyID");
      let pagingOnlyRadioBtn = document.querySelector("#pagingOnlyID");
      let searchingOnlyRadioBtn = document.querySelector("#searchingOnlyID");
      let pageSearchRadioBtn = document.querySelector("#pageSearchID");

      // console.log('gridOnlyRadioBtn.checked = ', gridOnlyRadioBtn.checked);

      this.$data.gridOnly = gridOnlyRadioBtn.checked;
      this.$data.pagingOnly = pagingOnlyRadioBtn.checked;
      this.$data.searchOnly = searchingOnlyRadioBtn.checked;
      this.$data.pageSearch = pageSearchRadioBtn.checked;

      //Since v-if is being used above, the data has to be retrieved when a grid instance
      //is to be shown. I could have used v-show instead and avoided this, but then all
      //grids would be populated, even when not shown.
      this.getAllUsers();
    },
  },
  components: { CmpGrid },
};
</script>

<style scoped>
.container-main-div {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 0px;
  margin-top: 20px;
  /* background-color: rgb(193, 236, 190); */
}

.gridWidth {
  width: 80%;
  margin-bottom: 50px;
}

/* ****************** radio buttons ********************* */

.divBorderLeft {
  border-left: solid rgb(196, 195, 195);
}

.fieldset {
  margin-left: 0%;
  margin-top: 0px;
  margin-bottom: 15px;
}
.float-container {
  border: 1px solid darkblue;
  padding: 5px;
}
.float-child {
  width: 100px;
  float: left;
  padding: 5px;
  margin-top: 5px;
}
.float-child-large {
  width: 130px;
  float: left;
  padding: 5px;
  margin-top: 5px;
}

.lableMargin {
  margin-left: 5px;
}
.customLegend {
  border: 1px solid #e5e5e5;
  padding: 0px;
  margin-top: 5px;
  position: relative;
}
.customLegend legend {
  border: 0;
  background: #fff;
  width: auto;
  font-size: 12px;
  transform: translateY(-50%);
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px;
}
</style>
